const API_PRINT_REPORT_REQUEST = 'API_PRINT_REPORT_REQUEST';
const API_PRINT_REPORT_SUCCESS = 'API_PRINT_REPORT_SUCCESS';
const API_PRINT_REPORT_FAILURE = 'API_PRINT_REPORT_FAILURE';

const API_SAVE_VERSION_REQUEST = 'API_SAVE_VERSION_REQUEST';
const API_SAVE_VERSION_SUCCESS = 'API_SAVE_VERSION_SUCCESS';
const API_SAVE_VERSION_FAILURE = 'API_SAVE_VERSION_FAILURE';

const API_LEARNER_VERSIONS_REQUEST = 'API_LEARNER_VERSIONS_REQUEST';
const API_LEARNER_VERSIONS_SUCCESS = 'API_LEARNER_VERSIONS_SUCCESS';
const API_LEARNER_VERSIONS_FAILURE = 'API_LEARNER_VERSIONS_FAILURE';
const RESET_LEARNER_VERSION = 'RESET_LEARNER_VERSION';

const ADD_PATH_TO_SAVE_VERSION = 'ADD_PATH_TO_SAVE_VERSION';
const RESET_PATH_TO_SAVE_VERSION = 'RESET_PATH_TO_SAVE_VERSION';

const SELECT_VERSION_ID_TO_SAVE = 'SELECT_VERSION_ID_TO_SAVE';

const RESET_SAVE_EDIT_VERSION = 'RESET_SAVE_EDIT_VERSION';

const API_OVERWRITE_VERSIONS_REQUEST = 'API_OVERWRITE_VERSIONS_REQUEST';
const API_OVERWRITE_VERSIONS_SUCCESS = 'API_OVERWRITE_VERSIONS_SUCCESS';
const API_OVERWRITE_VERSIONS_FAILURE = 'API_OVERWRITE_VERSIONS_FAILURE';

const VERSION_STATUS_REQUEST = 'VERSION_STATUS_REQUEST';
const VERSION_STATUS_SUCCESS = 'VERSION_STATUS_SUCCESS';
const VERSION_STATUS_FAILURE = 'VERSION_STATUS_FAILURE';

const RESET_OVERWRITE_VERSION = 'RESET_OVERWRITE_VERSION';
const SAVE_EDIT_POPUP = 'SAVE_EDIT_POPUP';

export const overwriteVersionRequest = () => ({
  type: API_OVERWRITE_VERSIONS_REQUEST,
});
export const overwriteVersionSuccess = payload => ({
  type: API_OVERWRITE_VERSIONS_SUCCESS,
  payload,
});
export const overwriteVersionFailure = payload => ({
  type: API_OVERWRITE_VERSIONS_FAILURE,
  payload,
});

export const resetOverwriteVersion = () => ({
  type: RESET_OVERWRITE_VERSION,
});

export const resetSaveEditForm = () => ({
  type: RESET_SAVE_EDIT_VERSION,
});

export const selectVersionIdToSave = payload => ({
  type: SELECT_VERSION_ID_TO_SAVE,
  payload,
});

export const addPathToSaveVersion = payload => ({
  type: ADD_PATH_TO_SAVE_VERSION,
  payload,
});

export const resetPathToSaveVersion = () => ({
  type: RESET_PATH_TO_SAVE_VERSION,
});
export const toggleSaveEditPopup = payload => ({
  type: SAVE_EDIT_POPUP,
  payload,
});

export const resetLearnerVersion = () => ({
  type: RESET_LEARNER_VERSION,
});
export const saveVersionRequest = () => ({
  type: API_SAVE_VERSION_REQUEST,
});

export const saveVersionSuccess = payload => ({
  type: API_SAVE_VERSION_SUCCESS,
  payload,
});
export const saveVersionFailure = payload => ({
  type: API_SAVE_VERSION_FAILURE,
  payload,
});

export const printReportRequest = payload => ({
  type: API_PRINT_REPORT_REQUEST,
  payload,
});
export const printReportSuccess = payload => ({
  type: API_PRINT_REPORT_SUCCESS,
  payload,
});
export const printReportFailure = payload => ({
  type: API_PRINT_REPORT_FAILURE,
  payload,
});

export const learnerVersionsRequest = () => ({
  type: API_LEARNER_VERSIONS_REQUEST,
});

export const learnerVersionsSuccess = payload => ({
  type: API_LEARNER_VERSIONS_SUCCESS,
  payload,
});

export const learnerVersionsFailure = payload => ({
  type: API_LEARNER_VERSIONS_FAILURE,
  payload,
});

const initialState = {
  isOverwriteVersion: null,
  overwriteVersionFetching: false,
  pathToSaveVersion: null,
  saveVersionFetching: null,
  isVersionSaved: null,
  printReportFetching: false,
  versionsPdf: null,
  selectedVersionId: null,
  isFetched: false,
  fetching: false,
  error: null,
  learnerVersions: null,
  saveEditPopup: false,
};

export function savedVersionsReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_OVERWRITE_VERSION:
      return {
        ...state,
        isOverwriteVersion: null,
        overwriteVersionFetching: false,
        error: null,
      };
    case API_OVERWRITE_VERSIONS_REQUEST:
      return {
        ...state,
        overwriteVersionFetching: true,
      };
    case API_OVERWRITE_VERSIONS_SUCCESS:
      return {
        ...state,
        overwriteVersionFetching: false,
        isOverwriteVersion: action.payload,
        saveEditPopup: false,
        error: null,
      };
    case API_OVERWRITE_VERSIONS_FAILURE:
      return {
        ...state,
        overwriteVersionFetching: false,
        error: action.payload,
      };
    case RESET_PATH_TO_SAVE_VERSION:
      return {
        ...state,
        pathToSaveVersion: null,
      };
    case RESET_LEARNER_VERSION:
      return {
        ...state,
        isFetched: false,
        learnerVersions: null,
      };
    case RESET_SAVE_EDIT_VERSION:
      return {
        ...state,
        isVersionSaved: null,
        error: null,
      };
    case SELECT_VERSION_ID_TO_SAVE:
      return {
        ...state,
        selectedVersionId: action.payload,
      };
    case ADD_PATH_TO_SAVE_VERSION:
      
      return {
        ...state,
        pathToSaveVersion: action.payload,
      };
      case SAVE_EDIT_POPUP:
        return {
          ...state,
          saveEditPopup: action.payload,
        };
    case API_SAVE_VERSION_REQUEST:
      return {
        ...state,
        saveVersionFetching: true,
      };
    case API_SAVE_VERSION_SUCCESS:
      return {
        ...state,
        saveVersionFetching: false,
        isVersionSaved: action.payload,
        saveEditPopup: false,
        error: null,
      };
    case API_SAVE_VERSION_FAILURE:
      return {
        ...state,
        saveVersionFetching: false,
        error: action.payload,
      };
    case API_PRINT_REPORT_REQUEST:
      return {
        ...state,
        printReportFetching: true,
      };
    case API_PRINT_REPORT_SUCCESS:
      return {
        ...state,
        printReportFetching: false,
        versionsPdf: action.payload,
      };
    case API_PRINT_REPORT_FAILURE:
      return {
        ...state,
        printReportFetching: false,
        error: action.payload,
        selectedVersionId: null,
      };
    case API_LEARNER_VERSIONS_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_LEARNER_VERSIONS_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        error: null,
        learnerVersions: action.payload,
      };
    case API_LEARNER_VERSIONS_FAILURE:
      return {
        ...state,
        fetching: false,
        isFetched: true,
        error: action.payload,
        learnerVersions: null,
      };
    default:
      return state;
  }
}
